var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      attrs: {
        width: "680px",
        "overlay-opacity": "0.8",
        fixed: "",
        temporary: "",
        right: "",
      },
      model: {
        value: _vm.isDialogOpen,
        callback: function ($$v) {
          _vm.isDialogOpen = $$v
        },
        expression: "isDialogOpen",
      },
    },
    [
      _c(
        "v-card",
        { staticClass: "pa-4" },
        [
          _c(
            "v-card-title",
            { staticClass: "d-flex align-center v-application mb-8" },
            [
              _c("p", [_vm._v("Manuelle Einrichtung")]),
              _vm._v(" "),
              _c("v-spacer"),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: { icon: "", small: "" },
                  on: {
                    click: function ($event) {
                      _vm.isDialogOpen = false
                    },
                  },
                },
                [_c("v-icon", [_vm._v("mdi-close")])],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-card-text",
            [
              _vm.current.trial_status === "requested"
                ? _c(
                    "v-alert",
                    { attrs: { type: "info", outlined: "", dense: "" } },
                    [
                      _vm._v(
                        "\n                Der Start aktiviert die separate Test-Steffi für volle 14 Tage ohne Kosten.\n                Anschließend beginnt das kostenpflichtige Abonnement automatisch, sofern die Testphase nicht beendet wurde.\n            "
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "v-row",
                { attrs: { dense: "" } },
                [
                  _c(
                    "v-col",
                    {
                      staticClass: "v-application--is-ltr",
                      attrs: { cols: "6" },
                    },
                    [
                      _c("v-text-field", {
                        attrs: {
                          dense: "",
                          outlined: "",
                          label: "Steffi Instanz ID",
                          disabled: !_vm.canUpdateManualSetup,
                          "data-test": "steffi-assistant-id",
                        },
                        model: {
                          value: _vm.manualSetupForm.famulor_assistant_id,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.manualSetupForm,
                              "famulor_assistant_id",
                              $$v
                            )
                          },
                          expression: "manualSetupForm.famulor_assistant_id",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-col",
                    {
                      staticClass: "v-application--is-ltr",
                      attrs: { cols: "6" },
                    },
                    [
                      _c("v-text-field", {
                        attrs: {
                          dense: "",
                          outlined: "",
                          label: "Steffi Instanz Name",
                          disabled: !_vm.canUpdateManualSetup,
                        },
                        model: {
                          value: _vm.manualSetupForm.famulor_assistant_name,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.manualSetupForm,
                              "famulor_assistant_name",
                              $$v
                            )
                          },
                          expression: "manualSetupForm.famulor_assistant_name",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-col",
                    {
                      staticClass: "v-application--is-ltr",
                      attrs: { cols: "4" },
                    },
                    [
                      _c("v-text-field", {
                        attrs: {
                          dense: "",
                          outlined: "",
                          label: "Telefonnummer ID",
                          disabled: !_vm.canUpdateManualSetup,
                          "data-test": "steffi-phone-id",
                        },
                        model: {
                          value: _vm.manualSetupForm.famulor_phone_id,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.manualSetupForm,
                              "famulor_phone_id",
                              $$v
                            )
                          },
                          expression: "manualSetupForm.famulor_phone_id",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-col",
                    {
                      staticClass: "v-application--is-ltr",
                      attrs: { cols: "4" },
                    },
                    [
                      _c("v-text-field", {
                        attrs: {
                          dense: "",
                          outlined: "",
                          label: "Telefonnummer",
                          disabled: !_vm.canUpdateManualSetup,
                          "data-test": "steffi-phone-number",
                        },
                        model: {
                          value: _vm.manualSetupForm.famulor_phone_number,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.manualSetupForm,
                              "famulor_phone_number",
                              $$v
                            )
                          },
                          expression: "manualSetupForm.famulor_phone_number",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-col",
                    {
                      staticClass: "v-application--is-ltr",
                      attrs: { cols: "4" },
                    },
                    [
                      _c("v-select", {
                        attrs: {
                          items: _vm.operationalStatusItems,
                          dense: "",
                          outlined: "",
                          clearable: "",
                          label: "Technischer Status",
                          disabled: !_vm.canUpdateManualSetup,
                        },
                        model: {
                          value: _vm.manualSetupForm.famulor_operational_status,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.manualSetupForm,
                              "famulor_operational_status",
                              $$v
                            )
                          },
                          expression:
                            "manualSetupForm.famulor_operational_status",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-col",
                    {
                      staticClass: "v-application--is-ltr",
                      attrs: { cols: "12" },
                    },
                    [
                      _c("v-textarea", {
                        attrs: {
                          dense: "",
                          outlined: "",
                          "auto-grow": "",
                          rows: "2",
                          "hide-details": "",
                          label: "Notizen",
                          disabled: !_vm.canUpdateManualSetup,
                        },
                        model: {
                          value: _vm.manualSetupForm.manual_setup_notes,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.manualSetupForm,
                              "manual_setup_notes",
                              $$v
                            )
                          },
                          expression: "manualSetupForm.manual_setup_notes",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-col",
                    {
                      staticClass: "v-application--is-ltr",
                      attrs: { cols: "5" },
                    },
                    [
                      _c("v-checkbox", {
                        staticClass: "mt-0",
                        attrs: {
                          label: "TechTest abgeschlossen",
                          disabled: !_vm.canUpdateManualSetup,
                          "data-test": "steffi-technical-test-finished",
                        },
                        model: {
                          value: _vm.manualSetupForm.technical_test_finished,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.manualSetupForm,
                              "technical_test_finished",
                              $$v
                            )
                          },
                          expression: "manualSetupForm.technical_test_finished",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _vm.current.can_activate ||
              _vm.current.can_send_customer_access_email
                ? _c("v-text-field", {
                    staticClass: "mb-4",
                    attrs: {
                      type: "password",
                      autocomplete: "new-password",
                      label: "Passwort für die Steffi-Zugangsmail",
                      hint: "Wird nur für diese Zugangsmail verwendet und nicht gespeichert.",
                      "persistent-hint": "",
                      outlined: "",
                      dense: "",
                      "data-test": "steffi-access-password",
                    },
                    model: {
                      value: _vm.customerAccessPassword,
                      callback: function ($$v) {
                        _vm.customerAccessPassword = $$v
                      },
                      expression: "customerAccessPassword",
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.current.onboarding_notification_sent_at
                ? _c(
                    "v-alert",
                    {
                      staticClass: "mb-2",
                      attrs: { type: "success", dense: "", outlined: "" },
                    },
                    [
                      _vm._v(
                        "\n                Interne Onboarding-Mail: " +
                          _vm._s(
                            _vm.formatDate(
                              _vm.current.onboarding_notification_sent_at
                            )
                          ) +
                          "\n            "
                      ),
                    ]
                  )
                : _vm.current.onboarding_notification_error
                ? _c(
                    "v-alert",
                    {
                      staticClass: "mb-2",
                      attrs: { type: "warning", dense: "", outlined: "" },
                    },
                    [
                      _vm._v(
                        "\n                Interne Onboarding-Mail konnte nicht gesendet werden.\n            "
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.current.customer_access_email_sent_at
                ? _c(
                    "v-alert",
                    {
                      staticClass: "mb-2 sent-at",
                      attrs: { type: "success", dense: "", outlined: "" },
                    },
                    [
                      _vm._v(
                        "\n                Steffi-Zugang gesendet an " +
                          _vm._s(_vm.current.customer_access_email_recipient) +
                          "\n            "
                      ),
                    ]
                  )
                : _vm.current.customer_access_email_error
                ? _c(
                    "v-alert",
                    {
                      staticClass: "mb-2",
                      attrs: { type: "warning", dense: "", outlined: "" },
                    },
                    [
                      _vm._v(
                        "\n                Steffi-Zugangsmail konnte nicht gesendet werden.\n            "
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.activationBlockerText
                ? _c(
                    "v-alert",
                    {
                      staticClass: "mb-0",
                      attrs: { type: "info", dense: "", outlined: "" },
                    },
                    [
                      _vm._v(
                        "\n                Aktivierung noch nicht möglich: " +
                          _vm._s(_vm.activationBlockerText) +
                          "\n            "
                      ),
                    ]
                  )
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-card-actions",
            { staticClass: "v-application mt-4" },
            [
              _vm.canUpdateManualSetup
                ? _c(
                    "v-btn",
                    {
                      attrs: {
                        outlined: "",
                        color: "primary",
                        loading: _vm.isSavingManualSetup,
                        "data-test": "steffi-save-manual-setup",
                      },
                      on: { click: _vm.saveManualSetup },
                    },
                    [_vm._v("\n                Speichern\n            ")]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  staticClass: "ml-4",
                  attrs: {
                    color: "primary",
                    disabled: !_vm.canRunActivationAction,
                    loading: _vm.isActivating,
                    "data-test": "steffi-activate",
                  },
                  on: { click: _vm.activateSteffi },
                },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.activationActionLabel) +
                      "\n            "
                  ),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }